// extracted by mini-css-extract-plugin
export default {"root":"DeleteApiKeyModal_root__sCnTJ","alertIcon":"DeleteApiKeyModal_alertIcon__WW87+","warning":"DeleteApiKeyModal_warning__t02EO","container":"DeleteApiKeyModal_container__MquIF"};